// extracted by mini-css-extract-plugin
export default {"container":"app_container__KI7PB","noSupport":"app_noSupport__g4Pgd"};